import angular from 'angular'
import template from './template.html'

export class NominasNominaInformacionCerrarComponent {
  constructor(NominasNomina, NominasNominaSuministro) {
    this.NominasNomina = NominasNomina
    this.NominasNominaSuministro = NominasNominaSuministro
    this.idEmpresa = undefined
    this.idNomina = undefined
    this.suministro = undefined
    this.onClose = undefined
    this.onCancel = undefined
    this.cerrando = false
    this.error = null
  }

  aceptar() {
    if (this.cerrando) return

    this.cerrando = true
    this.error = null

    this.NominasNominaSuministro.get(this.idEmpresa, this.idNomina)
      .then((suministro) => {
        // Por cada empleado
        let contenido = suministro.map((suministro) => {
          let deducciones = {},
            totalDeducciones = 0

          // Por cada deducción
          angular.forEach(suministro.Deducciones, (importe, idConcepto) => {
            let deduccion = suministro.Deducciones[idConcepto]
            deducciones[idConcepto] = angular.isNumber(deduccion.editado) ? deduccion.editado : deduccion.calculado

            totalDeducciones += deducciones[idConcepto]
          })

          return {
            ID_Empleado: suministro.ID_Empleado,
            ID_Empresa: suministro.ID_Empresa,
            Deducciones: deducciones,
          }
        })

        return this.NominasNomina.cerrarNomina(this.idEmpresa, this.idNomina, contenido)
          .then((response) => (this.onClose({$event: {data: response}})))
          .catch((response) => (this.error = response))
          .finally(() => (this.cerrando = false))
      })
  }
}

angular.module('nominas.nomina')
  .component('nominasNominaInformacionCerrar', {
    controller: NominasNominaInformacionCerrarComponent,
    template: template,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      suministro: '<',
      onClose: '&',
      onCancel: '&',
    },
  })



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/informacion/cerrar/component.js